import axios from "axios";
import { Fragment, useRef, useState } from "react";
import { useForm } from "react-hook-form";

import CircularProgress from "@material-ui/core/CircularProgress";
import PopupModal from "./Modal";
import { LessonPlanAPIs } from "../api";

export default function AddColumnModal({ userId, planIds, nextIndex, setColumns }) {
  const { register, reset, handleSubmit } = useForm({
    defaultValues: {
      columnType: "text",
    },
  });
  const btnRef = useRef();
  const [popup, setPopup] = useState({});
  const [addContentMessage, setAddContentMessage] = useState("");
  const [addContentLoader, setAddContentLoader] = useState(false);

  const submitResourceForm = async (data) => {
    if(addContentLoader) return;
    setAddContentMessage("");
    setAddContentLoader(true);

    try {
      if (!data.columnName) {
        throw new Error("Please provide columnName");
      }
      const payload = {
        planIds,
        colName: data.columnName,
        colType: data.columnType,
        colIndex: nextIndex,
      };

      const res = await axios.post(LessonPlanAPIs.addColumn(userId), payload, {
        headers: {
          token: localStorage.getItem("authToken"),
        },
        validateStatus: () => true,
      });
      if (res.data.status !== "success") throw res.data;
      const cells = res.data?.data?.cells || [];
      setColumns((prev) => [
        ...prev,
        {
          colName: data.columnName,
          colType: data.columnType,
          colIndex: nextIndex,
          cellIds: cells.map((cell) => cell._id),
          cells,
        },
      ]);
      setPopup({
        open: true,
        status: "Success",
        message: "Lesson plan created!",
      });

      reset();
      clearOnClose();
      btnRef.current.click();
    } catch (error) {
      console.log(error);
      if (error.response?.status === "fail") {
        setAddContentMessage(error.response.message);
      } else {
        setAddContentMessage(error.message || "Try Again.");
      }
    }

    setAddContentLoader(false);
  };

  const clearOnClose = () => {
    setAddContentLoader(false);
    setAddContentMessage("");
    reset();
  };

  return (
    <Fragment>
      <div
        className="modal fade resourceModel mt-5"
        id="columnModal"
        tabIndex="-1"
        aria-labelledby="resourceModalLabel"
        data-bs-backdrop="static"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{maxWidth:"300px !important"}}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="resourceModalLabel">
                ADD COLUMN
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form onSubmit={handleSubmit(submitResourceForm)}>
              <div className="modal-body">
                  <div
                    className="col-sm mb-3"
                  >
                    <div className="col-sm">
                      <label htmlFor="column-name" className="form-label">
                        Column Name
                      </label>
                      <input
                        type="text"
                        id={"column-name"}
                        name={"column-name"}
                        className="form-control form-control-sm"
                        {...register("columnName")}
                        style={{ fontSize: "1.05rem" }}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="col-sm">
                    <label htmlFor="column-type" className="form-label">
                      Subject
                    </label>
                    <select
                      className="form-select"
                      id="column-type"
                      {...register("columnType")}
                    >
                      <option defaultValue="" value={""}>
                        Select Type
                      </option>
                      {[
                        { name: "Text", value: "text" },
                        { name: "Custom Link", value: "link" },
                        { name: "2xcell Digital Resource", value: "resources" },
                      ].map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                
              </div>

              {addContentMessage && (
                <div className="text-center">
                  <p style={{ color: "#FF075B", fontWeight: "600" }}>
                    {addContentMessage}
                  </p>
                </div>
              )}

              <div className="mb-3 modal_button_container">
                <div className="row">
                  <div className="col d-grid">
                    <button
                      type="button"
                      className="btn resourceModelBtnCancel"
                      data-bs-dismiss="modal"
                      onClick={clearOnClose}
                      ref={btnRef}
                    >
                      Close
                    </button>
                  </div>
                  <div className="col d-grid">
                    {addContentLoader ? (
                      <div className="text-center">
                        <CircularProgress
                          style={{ color: "#FF075B", fontWeight: "600" }}
                        />
                      </div>
                    ) : (
                      <button
                        type="submit"
                        className="btn resourceModelBtnApply"
                      >
                        Add
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <PopupModal
        open={popup.open}
        heading={popup.status}
        message={popup.message}
      >
        <button
          style={{
            color: "#414141",
          }}
          onClick={() => setPopup({})}
        >
          Close
        </button>
      </PopupModal>
    </Fragment>
  );
}
